/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/** 当路由表太长时，可以将其拆分为小模块 **/

import Layout from '@/layout'

const homeRouter = [
  // 生产管理
  {
    path: '/plant',
    component: Layout,
    name: 'plant',
    meta: { title: '生产管理', icon: 'list', roles: ['plant'] },
    children: [
      {
        path: '/plantinfo',
        component: () => import('@/views/home/second'),
        name: 'plantinfo',
        meta: { title: '工厂信息', roles: ['plantinfo'] },
        children: [
          {
            path: '/plantmanage',
            component: () => import('@/views/home/third'),
            name: 'plantmanage',
            meta: { title: '工厂管理', roles: ['plantmanage'] },
            children: [
              {
                path: '/plantlist',
                component: () => import('@/views/home/plant/plantinfo/plantlist'),
                name: 'plantlist',
                meta: { noCache: true, title: '工厂列表', roles: ['plantlist'] }
              },
              {
                path: '/workshoplist',
                component: () => import('@/views/home/plant/plantinfo/workshoplist'),
                name: 'workshoplist',
                meta: { title: '车间列表', roles: ['workshoplist'], noCache: true }
              },
              {
                path: '/workline',
                component: () => import('@/views/home/plant/plantinfo/workline'),
                name: 'workline',
                meta: { title: '产线列表', roles: ['workline'], noCache: true }
              }
            ]
          },
          {
            path: '/classlist',
            component: () => import('@/views/home/plant/plantinfo/classlist'),
            name: 'classlist',
            meta: { title: '班组管理', roles: ['classlist'] }
          }
        ]
      },
      {
        path: '/production',
        component: () => import('@/views/home/second'),
        name: 'production',
        meta: { title: '生产信息', roles: ['production'] },
        children: [
          {
            path: '/orderlist',
            component: () => import('@/views/home/plant/production/order/orderlist'),
            name: 'orderlist',
            meta: { title: '工单列表', roles: ['orderlist'] }
          },
          {
            path: '/relevance',
            component: () => import('@/views/home/plant/production/relevance'),
            name: 'relevance',
            meta: { title: '包装关联', roles: ['relevance'] }
          },
          {
            path: '/unrelevance1',
            component: () => import('@/views/home/plant/production/unrelevance1'),
            name: 'unrelevance1',
            meta: { title: '关联解除', roles: ['unrelevance1'] }
          },
          {
            path: '/replace',
            component: () => import('@/views/home/plant/production/replace'),
            name: 'replace',
            meta: { title: '关联替换', roles: ['replace'] }
          },
          {
            path: '/taskmanagement',
            component: () => import('@/views/home/plant/production/taskmanagement'),
            name: 'taskmanagement',
            meta: { title: '任务管理', roles: ['taskmanagement'] }
          },
          {
            path: '/materialquery',
            component: () => import('@/views/home/plant/production/materialquery/materialquery'),
            name: 'materialquery',
            meta: { title: '原料投料管理', roles: ['materialquery'] }
          },
          {
            path: '/repeatedquery',
            component: () => import('@/views/home/plant/production/repeatedquery'),
            name: 'repeatedquery',
            meta: { title: '重码查询', roles: ['repeatedquery'] }
          },
          {
            path: '/harvestrate',
            component: () => import('@/views/home/plant/production/harvestrate'),
            name: 'harvestrate',
            meta: { title: '工单采集率', roles: ['harvestrate'] }
          },
          {
            path: '/orderextendlist',
            hidden: true,
            component: () => import('@/views/home/plant/production/orderextendlist/orderextendlist'),
            name: 'orderextendlist',
            meta: { title: '工单扩展属性' }
          },
          {
            path: '/workorderpacklist',
            hidden: true,
            component: () => import('@/views/home/plant/production/workorderpacklist/workorderpacklist'),
            name: 'workorderpacklist',
            meta: { title: '工单包装关系' }
          },
        ]
      }
    ]
  },
  // 物流管理
  {
    path: '/physical',
    component: Layout,
    name: 'physical',
    redirect: 'noRedirect',
    meta: { title: '物流管理', icon: 'table', roles: ['physical'] },
    children: [
      {
        path: '/shipmentsmanage',
        component: () => import('@/views/home/second'),
        name: 'shipmentsmanage',
        redirect: 'noRedirect',
        meta: { title: '发货管理', roles: ['shipmentsmanage'] },
        children: [
          {
            path: '/freight',
            component: () => import('@/views/home/physical/shipments/freight'),
            name: 'freight',
            meta: { title: '运单管理', roles: ['freight'] }
          },
          {
            path: '/boxcode',
            component: () => import('@/views/home/physical/shipments/boxcode'),
            name: 'boxcode',
            meta: { title: '箱码查询', roles: ['boxcode'] }
          },
          {
            path: '/Minderlieferung',
            component: () => import('@/views/home/physical/shipments/Minderlieferung'),
            name: 'Minderlieferung',
            meta: { title: '减货查询', roles: ['Minderlieferung'] }
          },
          {
            path: '/barter',
            component: () => import('@/views/home/physical/shipments/barter'),
            name: 'barter',
            meta: { title: '换货查询', roles: ['barter'] }
          },
          {
            path: '/RDCdissociated',
            component: () => import('@/views/home/physical/shipments/RDCdissociated'),
            name: 'RDCdissociated',
            meta: { title: '解除运单关联', roles: ['RDCdissociated'] }
          },
          {
            path: '/xiazai',
            component: () => import('@/views/home/xiazai.vue'),
            name: 'xiazai',
            meta: { title: '上传/下载', roles: ['xiazai'] }
          },
          {
            path: '/loglist',
            component: () => import('@/views/home/physical/shipments/loglist'),
            name: 'loglist',
            meta: { title: 'WMS出库异常日志', roles: ['loglist'] }
          }
        ]
      },
      {
        path: '/salesreturn',
        component: () => import('@/views/home/second'),
        name: 'salesreturn',
        redirect: 'noRedirect',
        meta: { title: '退货管理', roles: ['salesreturn'] },
        children: [
          {
            path: '/refund',
            component: () => import('@/views/home/physical/salesreturn/refund'),
            name: 'refund',
            meta: { title: '退货查询', roles: ['refund'] }
          },
          {
            path: '/dissociated',
            component: () => import('@/views/home/physical/salesreturn/dissociated'),
            name: 'dissociated',
            meta: { title: '解除运单关联', roles: ['dissociated'] }
          },
          {
            path: '/deliveryorder',
            component: () => import('@/views/home/physical/salesreturn/deliveryorder'),
            name: 'deliveryorder',
            meta: { title: '生产数据异常', roles: ['deliveryorder'] }
          }
        ]
      }
    ]
  },
  // 稽查管理
  {
    path: '/inspect',
    component: Layout,
    name: 'inspect',
    redirect: 'noRedirect',
    meta: { title: '稽查管理', icon: 'table', roles: ['inspect'] },
    children: [
      {
        path: '/forensics',
        component: () => import('@/views/home/inspect/forensics'),
        name: 'forensics',
        meta: { title: '取证记录', roles: ['forensics'] }
      },
      {
        path: '/inspectrecord',
        component: () => import('@/views/home/inspect/inspectrecord'),
        name: 'inspectrecord',
        meta: { title: '稽查记录', roles: ['inspectrecord'] }
      },
      {
        path: '/queryconsumerwarning',
        component: () => import('@/views/home/inspect/queryconsumerwarning'),
        name: 'queryconsumerwarning',
        meta: { title: '预警清单', roles: ['queryconsumerwarning'] }
      },
      {
        path: '/warningparam',
        component: () => import('@/views/home/inspect/warningparam'),
        name: 'warningparam',
        meta: { title: '配置预警参数', roles: ['warningparam'] }
      },
      {
        path: '/informationinquiry',
        component: () => import('@/views/home/inspect/informationinquiry'),
        name: 'informationinquiry',
        meta: { title: '信息查询', roles: ['informationinquiry'] }
      }
    ]
  },
  // 查询管理
  {
    path: '/querymanage',
    component: Layout,
    name: 'querymanage',
    redirect: 'noRedirect',
    meta: { title: '查询管理', icon: 'table', roles: ['querymanage'] },
    children: [
      {
        path: '/customerinquire',
        component: () => import('@/views/home/query/customerinquire'),
        name: 'customerinquire',
        meta: { title: '消费者查询页', roles: ['customerinquire'] }
      },
      {
        path: '/customerquery',
        component: () => import('@/views/home/query/customerquery'),
        name: 'customerquery',
        meta: { title: '消费者查询记录', roles: ['customerquery'] }
      },
      {
        path: '/scancode',
        component: () => import('@/views/home/query/scancode/scancode'),
        name: 'scancode',
        meta: { title: '扫码模板管理' },
      },
      {
        path: '/yyscancode',
        component: () => import('@/views/home/query/yyscancode/yyscancode'),
        name: 'yyscancode',
        meta: { title: '模板轮播图' }
      },
    ]
  },
  // 报表管理板块
  {
    path: '/report',
    component: Layout,
    name: 'report',
    redirect: 'noRedirect',
    meta: { title: '报表管理', icon: 'table', roles: ['report'] },
    children: [
      {
        path: '/check',
        component: () => import('@/views/home/second'),
        name: 'check',
        alwaysShow: true,
        meta: { title: '稽查报表', roles: ['check'] },
        children: [
          {
            path: '/supervise',
            component: () => import('@/views/home/report/supervise'),
            name: 'supervise',
            meta: { title: '市场监察', roles: ['supervise'] }
          }
        ]
      },
      {
        path: '/productionreport',
        component: () => import('@/views/home/second'),
        name: 'productionreport',
        meta: { title: '生产报表', roles: ['productionreport'] },
        children: [
          {
            path: '/collect',
            component: () => import('@/views/home/report/collect'),
            name: 'collect',
            meta: { title: '汇总报表', roles: ['collect'] }
          },
          {
            path: '/dateyield',
            component: () => import('@/views/home/report/dateyield'),
            name: 'dateyield',
            meta: { title: '日生产报表', roles: ['dateyield'] }
          },
          {
            path: '/productionorder',
            component: () => import('@/views/home/report/productionorder'),
            name: 'productionorder',
            meta: { title: '生产订单统计', roles: ['productionorder'] }
          }
        ]
      },
      {
        path: '/logistics',
        component: () => import('@/views/home/second'),
        name: 'logistics',
        meta: { title: '物流报表', roles: ['logistics'] },
        children: [
          {
            path: '/shipments',
            component: () => import('@/views/home/report/shipments'),
            name: 'shipments',
            meta: { title: '仓库发货端', roles: ['shipments'] }
          },
          {
            path: '/connect',
            component: () => import('@/views/home/report/connect'),
            name: 'connect',
            meta: { title: '成品交接单', roles: ['connect'] }
          },
          {
            path: '/phoenix',
            component: () => import('@/views/home/report/phoenix'),
            name: 'phoenix',
            meta: { title: '退货报表', roles: ['phoenix'] }
          }
        ]
      }
    ]
  }

]

export default homeRouter
